var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "test"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "col-md-offset-4 col-md-4"
  }, [_c('h1', {
    staticClass: "title text-center"
  }, [_vm._v("\n              " + _vm._s(_vm.title) + "\n            ")]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "formName"
    }
  }, [_vm._v("Full Name:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.name),
      expression: "model.name"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('name')
    },
    attrs: {
      "type": "text",
      "name": "name",
      "id": "formName"
    },
    domProps: {
      "value": (_vm.model.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.model.name = $event.target.value
      }
    }
  }), _vm._v(" \n                " + _vm._s(_vm.model.name) + "\n                          "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('name')),
      expression: "errors.has('name')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('name')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "formEmail"
    }
  }, [_vm._v("Email:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.email),
      expression: "model.email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('email')
    },
    attrs: {
      "type": "email",
      "name": "email",
      "id": "formEmail"
    },
    domProps: {
      "value": (_vm.model.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.model.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('email')),
      expression: "errors.has('email')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('email')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "formBio"
    }
  }, [_vm._v("Bio:")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.bio),
      expression: "model.bio"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:50'),
      expression: "'required|max:50'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "bio",
      "id": "formBio",
      "rows": "3"
    },
    domProps: {
      "value": (_vm.model.bio)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.model.bio = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('bio')),
      expression: "errors.has('bio')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('bio')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "formCoupon"
    }
  }, [_vm._v("Coupon:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.coupon),
      expression: "model.coupon"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|verify_coupon'),
      expression: "'required|verify_coupon'"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('coupon')
    },
    attrs: {
      "type": "text",
      "name": "coupon",
      "id": "formCoupon"
    },
    domProps: {
      "value": (_vm.model.coupon)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.model.coupon = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('coupon')),
      expression: "errors.has('coupon')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('coupon')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "formGender"
    }
  }, [_vm._v("Gender:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.gender),
      expression: "model.gender"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('gender')
    },
    attrs: {
      "name": "gender"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.model.gender = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', [_vm._v("Female")]), _vm._v(" "), _c('option', [_vm._v("Male")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('gender')),
      expression: "errors.has('gender')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('gender')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "formGender"
    }
  }, [_vm._v("Frameworks:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.frameworks),
      expression: "model.frameworks"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('frameworks')
    },
    attrs: {
      "name": "frameworks",
      "multiple": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.model.frameworks = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', [_vm._v("Vue")]), _vm._v(" "), _c('option', [_vm._v("Aurelia")]), _vm._v(" "), _c('option', [_vm._v("Preact")]), _vm._v(" "), _c('option', [_vm._v("Inferno")])]), _vm._v("\n                " + _vm._s(_vm.model.frameworks) + "\n                "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('frameworks')),
      expression: "errors.has('frameworks')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('frameworks')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "checkbox",
      "name": "subscribe"
    }
  }), _vm._v(" Subscribe me, please!\n                  " + _vm._s(_vm.model.subscribe) + "\n                ")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('subscribe')),
      expression: "errors.has('subscribe')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('subscribe')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Languages")]), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.languages),
      expression: "model.languages"
    }],
    attrs: {
      "type": "checkbox",
      "name": "languages",
      "value": "English"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.languages) ? _vm._i(_vm.model.languages, "English") > -1 : (_vm.model.languages)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.model.languages,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "English",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model.languages = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.model.languages = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.model.languages = $$c
        }
      }
    }
  }), _vm._v(" English\n                  ")]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.languages),
      expression: "model.languages"
    }],
    attrs: {
      "type": "checkbox",
      "name": "languages",
      "value": "French"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.languages) ? _vm._i(_vm.model.languages, "French") > -1 : (_vm.model.languages)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.model.languages,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "French",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model.languages = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.model.languages = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.model.languages = $$c
        }
      }
    }
  }), _vm._v(" French\n                  ")]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.languages),
      expression: "model.languages"
    }],
    attrs: {
      "type": "checkbox",
      "name": "languages",
      "value": "Ibo"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.languages) ? _vm._i(_vm.model.languages, "Ibo") > -1 : (_vm.model.languages)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.model.languages,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "Ibo",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model.languages = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.model.languages = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.model.languages = $$c
        }
      }
    }
  }), _vm._v(" Ibo\n                  ")]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.languages),
      expression: "model.languages"
    }],
    attrs: {
      "type": "checkbox",
      "name": "languages",
      "value": "Hausa"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.languages) ? _vm._i(_vm.model.languages, "Hausa") > -1 : (_vm.model.languages)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.model.languages,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "Hausa",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model.languages = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.model.languages = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.model.languages = $$c
        }
      }
    }
  }), _vm._v(" Hausa\n                  ")]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.languages),
      expression: "model.languages"
    }],
    attrs: {
      "type": "checkbox",
      "name": "languages",
      "value": "Yoruba"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.languages) ? _vm._i(_vm.model.languages, "Yoruba") > -1 : (_vm.model.languages)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.model.languages,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "Yoruba",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model.languages = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.model.languages = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.model.languages = $$c
        }
      }
    }
  }), _vm._v(" Yoruba\n                  ")])]), _vm._v("\n                " + _vm._s(_vm.model.languages) + "\n                "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('languages')),
      expression: "errors.has('languages')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('languages')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Happy")]), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.model.happy),
      expression: "model.happy"
    }],
    attrs: {
      "type": "radio",
      "name": "subscribe",
      "value": "Yes"
    },
    domProps: {
      "checked": _vm._q(_vm.model.happy, "Yes")
    },
    on: {
      "__c": function($event) {
        _vm.model.happy = "Yes"
      }
    }
  }), _vm._v(" Yes\n                  ")]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.model.happy),
      expression: "model.happy"
    }],
    attrs: {
      "type": "radio",
      "name": "happy",
      "value": "No"
    },
    domProps: {
      "checked": _vm._q(_vm.model.happy, "No")
    },
    on: {
      "__c": function($event) {
        _vm.model.happy = "No"
      }
    }
  }), _vm._v(" No\n                  ")])]), _vm._v("\n                " + _vm._s(_vm.model.happy) + "\n                          "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('happy')),
      expression: "errors.has('happy')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('happy')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "disabled": _vm.errors.any()
    }
  }, [_vm._v("Submit " + _vm._s(_vm.errors.any()))])])])])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41554a07","hasScoped":true}!./src/views/test/test.component.html
// module id = 1000
// module chunks = 1